import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

const mediaBarTemplate = htmlE`
  <div class="video-player" id="videoPlayer">
    <div class="info-bar px-2">
      <div class="video-bar">
        <i id="play" class="icon-play"></i>
        <input
          id="videoSlider"
          value="0"
          min="0"
          max="100"
          type="range"
          step="1" />
        <span class="ml-1" id="currentTime">0:00</span>
        <span class="p-0-3rem has-text-weight-bold">/</span>
        <span id="duration">0:00</span>
      </div>
      <div class="sound-bar ml-3">
        <i id="volumeIcon" class="icon-volume-up"></i>
        <input
          id="audioSlider"
          value="1"
          min="0"
          max="1"
          type="range"
          step="0.01" />
      </div>
      <div class="is-flex is-align-items-center ml-3">
        <i id="videoPlayerFullscreenButton" class="icon-resize-full"></i>
      </div>
    </div>
  </div>
`;

export default { mediaBarTemplate };
